import css from './events.module.scss';
import {Paper} from '../../components/paper/paper';
import {Venues} from '../../components/venues/venues';
import {EVENTS} from './events.mock';
import {useNavigate} from '@tanstack/react-location';

export const Events = (): JSX.Element => {
	const navigate = useNavigate();

	const onVenueSelect = (id: string) => {
		navigate({to: '/event-detail'});
		console.log('onVenueSelect: ', id);
	};

	return (
		<div className={css.container}>
			<div className={css.header}>
				<div className={css.title}>
					<span>Shows</span>
					<span>In Your City</span>
				</div>

				<Paper>
					<img width={16} src="/img/startIconGray.svg" />
					To get started, please select the venue / show you`re attending.
				</Paper>
			</div>

			<Venues onVenueSelect={onVenueSelect} list={EVENTS} />
		</div>
	);
};
